import { render, staticRenderFns } from "./PersonalInfo0.vue?vue&type=template&id=1c7520dc"
import script from "./PersonalInfo0.vue?vue&type=script&lang=js"
export * from "./PersonalInfo0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7520dc')) {
      api.createRecord('1c7520dc', component.options)
    } else {
      api.reload('1c7520dc', component.options)
    }
    module.hot.accept("./PersonalInfo0.vue?vue&type=template&id=1c7520dc", function () {
      api.rerender('1c7520dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfo0.vue"
export default component.exports